import CreateRoleForm from "../../../components/create/create-annonce-form";

export default function CreateCityPage() {
  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-4 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl max-xl:text-3xl font-bold bg-gradient-to-r from-[var(--color-primary-500)] to-[var(--color-primary-400)] bg-clip-text text-transparent mb-4">
            Ajouter Nouvelle Annonce
          </h1>
          <p className="text-sm max-xl:text-sm text-gray-600 max-w-2xl mx-auto">
            Ajoutez une nouvelle annonce à votre réseau avec ses informations et coûts associés.
          </p>
        </div>

        {/* Form Container */}
        <div className="mx-auto max-w-3xl">
          <CreateRoleForm />
        </div>
      </div>
    </div>
  )
}
